import request from '@/utils/request'
import axios from 'axios'

//特殊化请求
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 对应国际化资源文件后缀
axios.defaults.headers['Content-Language'] = 'zh_CN'
// 创建axios实例
const request_sp = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 15000,
})

// 栏目
const bbwSiteApi = {
    // jeecmsx2获取栏目树
    channelTree() {
        return request({
            url: '/channel/channelTree',
            method: 'GET',
        })
    },
    // jeecmsx2获取栏目列表
    channelList() {
        return request({
            url: '/channel/list',
            method: 'GET',
        })
    },
    // jeecmsx2获栏目详情byId
    channelDetail(id) {
        return request({
            url: '/channel/detail?id=' + id,
            method: 'GET',
        })
    },
    // jeecmsx2获栏目详情byId 栏目路径
    channelDetailByPath(channelPath) {
        return request({
            url: '/channel/getByPath?channelPath=' + channelPath + '&needDetail=true',
            method: 'GET',
        })
    },

    // jeecmsx2获 内容详情
    contentDetail(id) {
        return request({
            url: '/content/detail?id=' + id,
            method: 'GET',
        })
    },
    // jeecmsx2获 内容预览
    contentDetailPreview(id) {
        return request({
            url: '/content/detail?id=' + id+'&preview=true',
            method: 'GET',
        })
    },
    // jeecmsx2获 内容列表 by id
    contentPage(channelIds, page = 1, size = 10) {
        return request({
            url: `/content/page?channelIdStr=${channelIds}&pageNum=${page}&pageSize=${size}`,
            method: 'GET',
        })
    },
    // jeecmsx2获 内容列表 by 路径，第四参数是内容类型集合
    contentPageByPaths(channelPaths, page = 1, size = 10, typeIdStr = '') {
        return request({
            url: `/content/page?channelPaths=${channelPaths}&pageNum=${page}&pageSize=${size}&orderBy=0&typeIdStr=${typeIdStr}`,
            method: 'GET',
        })
    },
    // jeecmsx2获取友情链接
    sysLinkList() {
        return request({
            url: '/sysLink/list',
            method: 'GET',
        })
    },
    //智能表单详情 /front/intelligentform/detail
    intelligentformDetail(id) {
        return request({
            url: '/intelligentform/detail?id=' + id,
            method: 'GET',
        })
    },
    //智能表单提交 /front/intelligentform/submit
    intelligentformSubmit(form) {
        return request({
            url: '/intelligentform/submit',
            method: 'POST',
            data: form,
        })
    },
    //获取json文件
    getSiteJson(url) {
        return request({
            url: url,
            method: 'GET',
           // baseURL: "https://testnewcms.bbwcq.com/jsonget",
           baseURL: process.env.VUE_APP_U_GET,
        })
    },
    // 访问记录 该接口有可能出现错误，但不影响使用，因此使用特殊配置的请求
    accessRecordParse(path) {
        return request_sp({
            url: '/accessRecord/parse',
            method: 'POST',
            data: {
                'accessUrl': path
            }
        })
    }


}

export default bbwSiteApi
